import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import "./index.scss";
import Button from "../../common/Button";

export default function Help() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Backend can be connected later
    console.log("Enquiry submitted:", formData);

    alert("Thank you for contacting EA Trade Support. We will get back to you soon.");

    setFormData({
      name: "",
      email: "",
      subject: "",
      message: ""
    });
  };

  return (
    <>
      <div className="mr-0 ml-0 p-2 mt-2 mb-0">
        <h3>Help & Support</h3>
      </div>

      <Container fluid className="p-4">

        {/* ===== Introduction ===== */}
        <Row className="mb-4">
          <Col md={12}>
            <div className="bg-white p-4 box-hover rounded">
              <h5>EA Trade Support Team</h5>
              <p className="text-muted mt-2">
                Our EA Trade Support team is dedicated to helping you with any
                questions, technical issues, or general enquiries related to our
                services. We aim to provide fast, reliable, and friendly support
                to ensure you get the best experience.
              </p>

              <p className="mt-3">
                Need instant help?{" "}
                <a
                  href="https://wa.me/27600000000"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="theme-color font-weight-bold"
                >
                  Click here to contact / connect with us via WhatsApp
                </a>
              </p>
            </div>
          </Col>
        </Row>

        {/* ===== Enquiry Form ===== */}
        <Row>
          <Col md={8} lg={6}>
            <div className="bg-white p-4 box-hover rounded">
              <h5 className="mb-3">Send Us an Enquiry</h5>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button type="submit"  active="btn-deactive my-3" title="Submit Enquiry" />
              </Form>
            </div>
          </Col>
        </Row>

      </Container>
    </>
  );
}
